import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { amountAtom } from '../../_shared/atoms/prepaidCardAtoms';
import { nameAtom } from '../atoms/purchasePrepaidCardAtoms';

interface Props {
    cardName?: string;
    amount?: number;
}

function useInitialValues({ cardName, amount }:Props) {
    const setName = useSetAtom(nameAtom);
    const setAmount = useSetAtom(amountAtom);
    useEffect(() => {
        if (cardName) {
            setName(cardName);
        }
        if (amount) {
            setAmount(amount);
        }
    }, [cardName, amount]);
}

export default useInitialValues;
